import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/logo.svg'
import _imports_1 from '@/assets/icons/icon-github.svg'


const _hoisted_1 = { class: "bg-primary-base fixed w-full z-20 top-0 left-0 sm:h-20 shadow-md" }
const _hoisted_2 = { class: "flex flex-wrap justify-between items-center mx-auto" }
const _hoisted_3 = { class: "sm:bg-black flex-none sm:bg-opacity-20 sm:w-1/4 w-2/4 sm:h-20 py-5 px-5 flex justify-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Perfil Político"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex sm:flex-none md:order-2 px-2 sm:px-6 py-2.5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "c-footer__content-link-project flex items-center p-3 h-full rounded-lg bg-white bg-opacity-10" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "Github"
    }),
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://github.com/okfn-brasil/perfil-politico-frontend",
        target: "_blank",
        rel: "noopener noreferrer",
        class: "ml-2 text-white hover:underline"
      }, "Ver Github")
    ])
  ])
], -1)
const _hoisted_6 = {
  class: "hidden sm:w-3/5 grow md:flex md:order-1",
  id: "navbar-sticky"
}
const _hoisted_7 = {
  key: 0,
  selected: "",
  disabled: "",
  value: ""
}
const _hoisted_8 = ["value", "selected"]
const _hoisted_9 = {
  key: 0,
  selected: "",
  disabled: "",
  value: ""
}
const _hoisted_10 = ["value", "selected"]
const _hoisted_11 = { class: "hidden relative md:block w-full h-full" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-5 h-5",
    fill: "none",
    stroke: "#ffffff",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    })
  ])
], -1)
const _hoisted_13 = {
  key: 0,
  class: "hidden md:block"
}
const _hoisted_14 = { class: "list-search inline-block absolute z-10 box-content py-2 px-3 text-sm font-medium text-white bg-primary-dark rounded-lg shadow-sm" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "w-full capitalize" }
const _hoisted_17 = {
  key: 0,
  class: "px-2 py-3"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Não encontramos resultados para sua pesquisa!", -1)
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: { name: 'Home' } }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("select", {
          id: "roleCandidates",
          name: "roleCandidates",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectRoleNavbar && _ctx.selectRoleNavbar(...args))),
          class: "bg-white bg-opacity-10 h-full p-3 text-white text-sm rounded-l-lg border-transparent font-regular focus:ring-secondary-base focus:border-secondary-base block",
          placeholder: "Cargo",
          required: ""
        }, [
          (!_ctx.currentRole.value)
            ? (_openBlock(), _createElementBlock("option", _hoisted_7, " Cargo "))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.roles, (role) => {
            return (_openBlock(), _createElementBlock("option", {
              key: role.id,
              value: role.id,
              selected: _ctx.currentRole === role.id ? true : false
            }, _toDisplayString(role.name), 9, _hoisted_8))
          }), 128))
        ], 32),
        _createElementVNode("select", {
          id: "localeCandidates",
          name: "localeCandidates",
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.localeNavbarCandidates && _ctx.localeNavbarCandidates(...args))),
          class: "bg-background-purpleLight h-full p-3 text-white text-sm font-regular border-transparent focus:ring-secondary-base focus:border-secondary-base",
          required: "",
          placeholder: "Localidade"
        }, [
          (_ctx.currentLocale === 'br' || !_ctx.currentLocale.value)
            ? (_openBlock(), _createElementBlock("option", _hoisted_9, " Estado "))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.locales, (locale, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: locale.initials,
              selected: _ctx.currentLocale === locale.initials ? true : false
            }, _toDisplayString(locale.name), 9, _hoisted_10))
          }), 128))
        ], 32),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "search-navbar",
            class: "block p-3 pl-10 w-full text-white bg-white bg-opacity-20 placeholder-white border-transparent rounded-r-lg sm:text-sm focus:ring-secondary-base focus:border-secondary-base focus:bg-background-purpleLight",
            placeholder: "Digite o nome da pessoa candidata",
            autocomplete: "off",
            required: "",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchListCandidates.name) = $event)),
            onInput: _cache[3] || (_cache[3] = ($event: any) => (
              _ctx.searchListCandidates.name.length > 1
                ? (_ctx.showListCandidates = true)
                : (_ctx.showListCandidates = false)
            ))
          }, null, 544), [
            [_vModelText, _ctx.searchListCandidates.name]
          ]),
          (_ctx.showListCandidates)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("ul", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredList.slice(0, 4), (candidate) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: candidate.id,
                      class: "w-full cursor-pointer px-2 py-3 border-b border-primary-base",
                      onClick: ($event: any) => (
                  (_ctx.searchListCandidates.name = candidate.name),
                    (_ctx.searchListCandidates.id = candidate.id),
                    (_ctx.showListCandidates = false)
                )
                    }, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(candidate.name), 1)
                    ], 8, _hoisted_15))
                  }), 128)),
                  (_ctx.searchListCandidates && !_ctx.filteredList.length)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_17, _hoisted_19))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "flex-none text-primary-base sm:w-auto sm:mt-0 xs:block w-full mt-4 uppercase font-bold bg-secondary-base font-medium rounded-lg ml-2 text-sm px-5 py-3 text-center mr-2 mb-2",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleSearchCandidate(_ctx.searchListCandidates.id)))
        }, " Buscar ")
      ])
    ])
  ]))
}